namespace GeniuzPOS.InitialData {
    export interface PsQRPromptPayRow {
        Id?: number;
        QRPromptPayType?: string;
        QRPromptPayName?: string;
        paymentChannel?: string;
        ProdImageLink?: string;
        IsActive?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsQRPromptPayRow {
        export const idProperty = 'QRPromptPayType';
        export const nameProperty = 'QRPromptPayName';
        export const localTextPrefix = 'InitialData.PsQRPromptPay';
        export const lookupKey = 'InitialData.PsQRPromptPay';

        export function getLookup(): Q.Lookup<PsQRPromptPayRow> {
            return Q.getLookup<PsQRPromptPayRow>('InitialData.PsQRPromptPay');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทQRPayment:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทQRPayment:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทQRPayment:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทQRPayment:Modify';

        export declare const enum Fields {
            Id = "Id",
            QRPromptPayType = "QRPromptPayType",
            QRPromptPayName = "QRPromptPayName",
            paymentChannel = "paymentChannel",
            ProdImageLink = "ProdImageLink",
            IsActive = "IsActive",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
